<template>
    <section class="welcome">
        <h1><slot/></h1>
    </section>
</template>

<script>
    export default {
        name: 'Welcome',
        created: function() {
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        }
    }
</script>

<style lang="sass" scoped>
    section
        width: 100%
        display: flex
        flex-wrap: wrap
        flex-direction: column
        justify-content: center
        align-content: center
        height: 100vh
        height: calc(var(--vh, 1vh) * 100)
        padding: 0 20px

        h1
            width: 100%
            text-align: center
            font-weight: bold
            font-size: 60px
            line-height: 72px

            .small
                font-size: 30px

    @media screen and (max-width: $mobile-break-point)
        body
          &.en
            h1
              text-align: left

        section
            h1
                text-align: right
                font-size: 40px
                line-height: 52px

                .br-mobile
                    display: block

                br
                    content: " "
                    display: none

                .small
                    line-height: 1
                    margin-top: 20px
                    font-size: 24px
</style>